import React, { useEffect, useState } from 'react';
import './WorkshopTable.scss';
import { useGetOnboardWorkshopDataQuery } from '../../../Services/vehicle/Vehicle';
import { useNavigate } from 'react-router-dom';
import { capitalizeFirstLetter } from '../../../components/reusableComponent/CapitalLetter';
import LoadingSpinner from '../../../components/LoadingSpinner';
import ReactModal from 'react-modal';
import ConfirmationModal from './ConfirmationModal';
import InactiveWorkshopModal from './InactiveWorkshopModal';


const ITEMS_PER_PAGE = 20;

 
const ListedWorkshops = () => {

  const [getWorkshopData, setGetWorkshopData] = useState<any>([])
const [totalItems, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false)
  const [isInactiveModalOpen, setIsInactiveModalOpen] = useState(false)
   const [isActiveModalOpen, setIsActiveModalOpen] = useState(false)
   const [storedWOrkshopData, setStoredWorkshopData] = useState({})


    const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, totalItems);

      const { data: workshopData, isLoading, status: workshopStatus, refetch } = useGetOnboardWorkshopDataQuery(currentPage);

      const navigte = useNavigate()

      useEffect(() => {
        if (workshopStatus === "pending") {
          setLoading(true)

        }
        else {
          setLoading(false)
        }

      }, [workshopStatus])


      useEffect(() => {
        if (workshopData) {
          setGetWorkshopData(workshopData)
      setTotalCount(workshopData?.count || 0);


        }

      }, [workshopData])


  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      // Ideally trigger a data fetch here if paginated server-side
    }
  };


  const completeWorkshopDataHandler = (id) => {
    navigte(`${id}`, {state: id})

  }

    const editWorkshopDataHandler = (id) => {

    navigte(`/vehicle/workshop-edit/${id}`, {state: id})

  }

  const inactiveHandler = (workshop) => {
    setStoredWorkshopData(workshop)
    setIsActiveModalOpen(true)

  }


  const activeHandler = (workshop) => {
    setStoredWorkshopData(workshop)
    setIsInactiveModalOpen(true)
  }

  const closeModal = () => {
    setIsInactiveModalOpen(false)
    setIsActiveModalOpen(false)
  }


   const customModalStyles1: ReactModal.Styles = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-40%, -50%)",
        width: "40%",
      },
    };
  
 
    console.log(currentPage, "currentPagege")
  return (
    <div className="workshops-container">
      <div className="workshops-header">
        <h2 className="workshops-title" style={{fontSize: "20px"}} >Workshops</h2>
        <div className="workshops-buttons">
          {/* <button className="upload-bulk-btn">Upload Bulk</button>
          <button className="add-workshop-btn">Add Workshop</button> */}
        </div>
      </div>
{isLoading || loading ? <LoadingSpinner /> : 


      <div className="workshops-table-container">
        <table className="workshops-table">
          <thead>
            <tr style={{background: "#F7D3C5"}}>
              <th className="table-header">Sr.No.</th>
              <th className="table-header">Workshop</th>
              <th className="table-header">City</th>
              <th className="table-header">Admin</th>
              <th className="table-header">Mobile</th>
              <th className="table-header">Created by</th>
              <th className='table-header'>Status</th>
              {/* <th className='table-header'>Active/Inactive</th> */}
              <th className="table-header">Actions</th>
            </tr>
          </thead>
          <tbody>
            {getWorkshopData?.map((workshop, index) => (
              <tr
                key={workshop.id}
                className={index % 2 === 1 ? 'row-alternate' : 'row-normal'}
              >
                <td className="table-cell">{index + 1}</td>
                <td className="table-cell" style={{maxWidth: "200px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis"}}>{capitalizeFirstLetter(workshop?.workshopName)}</td>
                <td className="table-cell">{capitalizeFirstLetter(workshop?.city)}</td>
                <td className="table-cell" style={{maxWidth: "150px", overflow: "hidden", whiteSpace: "nowrap",   textOverflow: "ellipsis",}}>{capitalizeFirstLetter(workshop.workShopAdministrationName)}</td>
                <td className="table-cell">{workshop.workShopAdministrationPhoneNumber}</td>
                <td className="table-cell">{workshop?.created_by}</td>
                <td className="table-cell">{capitalizeFirstLetter(workshop.status)}</td>


                <td className="table-cell">
                {workshop?.status !== "rejected" && 
                  <div className="action-buttons">
                    <button className="view-btn">
                      <span data-toggle="tooltip" data-placement="top" title="Preview" className="icon eye-icon" onClick={() => completeWorkshopDataHandler(workshop?.id)}></span>
                    </button>
                    <button className="edit-btn">
                      <span data-toggle="tooltip" data-placement="top" title="Edit" className="icon edit-icon" onClick={() => editWorkshopDataHandler(workshop?.id)}></span>
                    </button>
                    <div>
                      {workshop?.is_active ? 
                      
                      <span onClick={() => inactiveHandler(workshop)}>

                      <img src='/Active.svg' alt='active' />
                      </span>
                      :
                      <span onClick={() => activeHandler(workshop)}>

                      <img src='/Inactive.svg' alt='inactive'/>
                      </span>
                         }

                    </div>
                    {/* <button className="delete-btn">
                      <span className="icon delete-icon" onClick={() => inactiveHandler(workshop) }></span>
                    </button> */}
                  </div>
}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      }
 
    {/* <div className="pagination-footer">
        <div className="pagination-info">
          Showing {startIndex + 1} - {endIndex} of {totalItems}
        </div>

        <div className="pagination-controls">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-btn"
          >
            Prev
          </button>

          {[...Array(totalPages)].map((_, i) => {
            const pageNum = i + 1;
            return (
              <button
                key={pageNum}
                onClick={() => handlePageChange(pageNum)}
                className={`pagination-btn ${pageNum === currentPage ? 'active' : ''}`}
              >
                {pageNum}
              </button>
            );
          })}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-btn"
          >
            Next
          </button>
        </div>
      </div> */}

            <ReactModal
              isOpen={isInactiveModalOpen}
              onRequestClose={closeModal}
              style={customModalStyles1}
            
            >
              <ConfirmationModal

              storedWorkshopData={storedWOrkshopData}


                closeModal={closeModal}
                refetch={refetch}

             
              />
            </ReactModal>



             <ReactModal
              isOpen={isActiveModalOpen}
              onRequestClose={closeModal}
              style={customModalStyles1}
            
            >
              <InactiveWorkshopModal

              storedWorkshopData={storedWOrkshopData}
                closeModal={closeModal}
                refetch={refetch}
    
              />
            </ReactModal>




         






    </div>
  );
};
 
export default ListedWorkshops;